export default __webpack_public_path__ + "static/media/blog-kids-studying.b9e7c6cb.jpg";